module.exports = __webpack_public_path__ + "static/media/v-circle1.6cbe572d.png";